import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Button } from 'antd';

import iconUbicacion from '../../../img/concesionario/icono_ubicacion.svg';
import iconRepuestos from '../../../img/concesionario/icono_repuesto.svg';
import iconServicio from '../../../img/concesionario/icono_Servicio.svg';
import iconVenta from '../../../img/concesionario/icono_venta.svg';

import '../../../css/textsPredefined.css';
import './tarjetaConcesionario.css';
import { Link } from 'react-router-dom';


const TarjetaConcesionario = ({ concesionario, vieneServicios }) => {
    const [serviciosBool, setServicios] = useState({ Venta: false, Repuestos: false, Servicio: false });

    const { Venta, Repuestos, Servicio } = serviciosBool;

    const { servicios } = concesionario;

    useEffect(() => {
        let venta = false;
        let repuestos = false;
        let servi = false;

        if (servicios && servicios.length > 0) {
            servicios.map((servicio) => {
                if (servicio.Servicio === "Venta" && servicio.Estado === "A") {
                    venta = true;
                }
                else if (servicio.Servicio === "Repuestos" && servicio.Estado === "A") {
                    repuestos = true;
                }
                else if (servicio.Servicio === "Servicio" && servicio.Estado === "A") {
                    servi = true;
                }
                return true
            })
        };

        setServicios({ Venta: venta, Repuestos: repuestos, Servicio: servi });

    }, [servicios]);

    if(!concesionario) return null;
    return (
        <Col xs={12} lg={6} xl={4} className="border-right-con border-row-zona my-0 my-md-3">
            <Container className="mt-3 mt-md-0 " fluid>
                <Row>
                    <Col xs={12}>
                        <h5 className="bold-title-hyundai f-responsive mb-0 mb-md-1">{concesionario.Nombre}</h5>
                        <p className="parrafo-hyundai f-responsive-10">{concesionario.Region},  {concesionario.Sucursal}</p>
                    </Col>
                </Row>
                <Row className="mx-0">
                    <Col xs={12} className="brd-direccion-c px-0 px-md-1">
                        <Row>
                            <Col xs={3} md={2} className="px-0">
                                <img src={iconUbicacion} className="img-fluid icono-ubicacion" alt="ubicacion" />
                            </Col>
                            <Col xs={9} md={10} className="px-0 align-self-center">
                                <p className="parrafo-hyundai my-0 my-md-1 f-responsive-10"> {concesionario.Direccion}</p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="mt-3 mb-4 mb-md-3">
                        <h6 className="bold-title-hyundai mb-md-2 f-responsive-10">Tipo de atención:</h6>
                        <Row>
                            <Col xs={8} md={12}>
                                <Row>
                                    {Venta === true && !vieneServicios &&
                                        <Col xs="auto" className="text-center pr-1 pr-md-2">
                                            <img src={iconVenta} className="icon-servicio" alt="venta" />
                                            <p className="parrafo-hyundai font-text-c f-responsive-10">Vehículos</p>
                                        </Col>
                                    }
                                    {Repuestos === true &&
                                        <Col xs="auto" className="text-center pr-1 pr-md-2">
                                            <img src={iconRepuestos} className="icon-servicio" alt="repuestos" />
                                            <p className="parrafo-hyundai font-text-c f-responsive-10">Repuestos</p>
                                        </Col>
                                    }
                                    {Servicio === true &&
                                        <Col xs="auto" className="text-center pr-1 pr-md-2">
                                            <img src={iconServicio} className="icon-servicio" alt="servicios" />
                                            <p className="parrafo-hyundai font-text-c f-responsive-10">Servicio</p>
                                        </Col>
                                    }
                                </Row>
                            </Col>
                            <Col xs={4} className="d-md-none text-center pl-0">
                                <Link to={`/concesionario/${concesionario.SlugConcesionario}/${concesionario.SlugOficina}`}>
                                    <Button className="mb-1 ml-0 w-100 btn-primario font-btn">Contacto</Button>
                                </Link>
                                <a href={`https://www.google.com/maps/search/?api=1&query=${concesionario.Localizacion}`} target="_blank" rel="noopener noreferrer">
                                    <Button className="ml-0 w-100 btn-secundario font-btn">Ver mapa</Button>
                                </a>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="d-none d-md-block mb-5" >
                        <Link to={`/concesionario/${concesionario.SlugConcesionario}/${concesionario.SlugOficina}`}>
                            <Button id="btn-con" className="btn-primario mr-2 px-4  font-btn">Contacto</Button>
                        </Link>
                        <a href={`https://www.google.com/maps/search/?api=1&query=${concesionario.Localizacion}`} target="_blank" rel="noopener noreferrer">
                            <Button id="btn-con" className="btn-secundario font-btn px-4">Ver mapa</Button>
                        </a>
                    </Col>
                </Row>
                {/* <Container className="d-md-none brd-direccion-c" fluid>
                    <Col className="brd-direccion-c d-md-none"></Col> 
                </Container> */}
            </Container>
        </Col >);
}

export default TarjetaConcesionario;